<ion-card class="coupon-card">
  <ion-card-header>
    <ion-card-subtitle>{{ couponItem.title }}</ion-card-subtitle>
    <ion-card-title>{{ couponItem.subtitle }}</ion-card-title>
  </ion-card-header>
  <ion-card-content>
    <div class="coupon-barcode">
      <ion-img [src]="couponItem.barcode_image_url"></ion-img>
    </div>
    <div class="coupon-code" (click)="copyAndShop(couponItem)">
      {{"shared.coupon_card.coupon_code" | translate}} : <span>{{ couponItem.code }}</span>
    </div>
  </ion-card-content>
  <div class="ion-padding footer">
    <span>
      {{"shared.coupon_card.validity_until" | translate}}
      {{ couponItem.valid_till_date.date | smartdate }}
    </span>
  </div>
  <div class="coupon-card-tc--container">
    <a
      class="coupon-card-tc"
      href="https://travelx.ai/delhi-duty-free-offers-terms-2/"
      target="_blank"
    >
     {{"shared.coupon_card.terms_and_conditions" | translate}}
    </a>
  </div>
</ion-card>
